import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Vendor } from './vendor';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class VendorService {
	
baseUrl = environment.baseUrl;

  private vendorsUrl = this.baseUrl + '/api/vendors';  // URL to web api
    private getvendorlistUrl = this.baseUrl + '/api/vendors/getvendorlist';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getVendors (): Observable<Vendor[]> {
    return this.http.get<Vendor[]>(this.vendorsUrl)
  }
   getVendorlist (): Observable<Vendor[]> {
    return this.http.get<Vendor[]>(this.baseUrl +'/api/vendorlist')
  }
    GetTopVendors (): Observable<Vendor[]> {
    return this.http.get<Vendor[]>(this.baseUrl +'/api/GetTopVendors')
  }
  GetAlltTopVendors (): Observable<Vendor[]> {
    return this.http.get<Vendor[]>(this.baseUrl +'/api/GetAllTopVendors')
  }
  getVendor(vendorid: number): Observable<Vendor> {
    const url = `${this.vendorsUrl}/${vendorid}`;
    return this.http.get<Vendor>(url);
  }
  
   getvendorlistByRequirement(requirement: number): Observable<Vendor> {
    const url = `${this.getvendorlistUrl}/${requirement}`;
    return this.http.get<Vendor>(url);
  }
 
  addVendor (vendor: Vendor): Observable<Vendor> {
    return this.http.post<Vendor>(this.vendorsUrl, vendor, httpOptions);
  }
 
  deleteVendor (vendor: Vendor | number): Observable<Vendor> {
    const id = typeof vendor === 'number' ? vendor : vendor.vendorid;
    const url = `${this.vendorsUrl}/${id}`;
 
    return this.http.delete<Vendor>(url, httpOptions);
  }
 
  updateVendor (vendor: Vendor): Observable<any> {
    return this.http.put(this.vendorsUrl, vendor, httpOptions);
  }
}